module.exports = __webpack_public_path__ + "img/cj04.36fcafea.jpg";